/**
 * 48-team World Cup 2026 country list. Mirrored to
 * `agent-app/src/data/wc2026-countries.ts` — keep in sync. Used by the
 * admin Creator drawer's profile editor for the single
 * `world_cup_country` dropdown that replaced the trio of country-related
 * fields. Refine before final group-stage publication.
 */
export const WC2026_COUNTRIES: readonly string[] = [
  'Canada',
  'Mexico',
  'United States',
  'Austria',
  'Belgium',
  'Croatia',
  'Czech Republic',
  'Denmark',
  'England',
  'France',
  'Germany',
  'Hungary',
  'Italy',
  'Netherlands',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'Scotland',
  'Serbia',
  'Slovakia',
  'Spain',
  'Sweden',
  'Switzerland',
  'Turkey',
  'Ukraine',
  'Argentina',
  'Bolivia',
  'Brazil',
  'Chile',
  'Colombia',
  'Ecuador',
  'Paraguay',
  'Peru',
  'Uruguay',
  'Costa Rica',
  'Honduras',
  'Jamaica',
  'Panama',
  'Australia',
  'Iran',
  'Iraq',
  'Japan',
  'Qatar',
  'Saudi Arabia',
  'South Korea',
  'United Arab Emirates',
  'Algeria',
  'Cameroon',
  'Egypt',
  'Ghana',
  'Ivory Coast',
  'Morocco',
  'Nigeria',
  'Senegal',
  'Tunisia',
  'New Zealand',
];
